import { render } from "./PreparationCard.vue?vue&type=template&id=ef8fbcba&scoped=true"
import script from "./PreparationCard.vue?vue&type=script&lang=js"
export * from "./PreparationCard.vue?vue&type=script&lang=js"

import "./PreparationCard.vue?vue&type=style&index=0&id=ef8fbcba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef8fbcba"]])

export default __exports__